import { CalendarCheck, Truck, MessageCircleQuestion, FileText } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const ICONS = { devis: FileText, rdv: CalendarCheck, pickup: Truck, question: MessageCircleQuestion };

export const RequestTypeSwitch = ({ value, onChange }) => {
  const { t } = useLanguage();
  return (
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-4" role="tablist" data-testid="contact-type-switch">
      {Object.entries(t.contact.types).map(([k, v]) => {
        const Icon = ICONS[k];
        const on = value === k;
        return (
          <button key={k} type="button" role="tab" aria-selected={on} onClick={() => onChange(k)} data-testid={`contact-type-${k}`}
            className={`group flex flex-col items-start gap-3 rounded-2xl border p-5 text-left transition-all duration-300 ${on ? "border-gold bg-white shadow-xl shadow-gold/10" : "border-brand/15 bg-white/60 hover:border-brand/40 hover:bg-white"}`}>
            <span className={`flex h-10 w-10 items-center justify-center rounded-xl transition-colors ${on ? "bg-gold text-white" : "bg-mint text-brand group-hover:bg-brand group-hover:text-white"}`}><Icon className="h-5 w-5" /></span>
            <span className="font-display text-base font-bold leading-snug text-forest">{v.title}</span>
            <span className="text-xs leading-relaxed text-brand-hover">{v.desc}</span>
          </button>
        );
      })}
    </div>
  );
};
